// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(env: string = 'dev'): Record<string, any> {
  return {
    ELC_ENV: env,
    'ut.env': env,
  };
}
